import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { syncBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { SyncedBlockErrorStateCard } from './SyncedBlockErrorStateCard';

const styles = cssMap({
	buttonContainer: {
		marginLeft: token('space.100'),
		display: 'flex',
		alignItems: 'center',
	},
});

interface SyncedBlockLoadErrorProps {
	isLoading?: boolean;
	onRetry?: () => void;
}

export const SyncedBlockLoadError = ({
	onRetry,
	isLoading,
}: SyncedBlockLoadErrorProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const button = (
		<Button
			appearance="default"
			spacing="compact"
			// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
			onClick={(event) => {
				event.preventDefault();
				event.stopPropagation();
				onRetry?.();
			}}
			isLoading={isLoading}
			testId="sync-block-retry-btn"
		>
			{formatMessage(messages.retryButton)}
		</Button>
	);
	return (
		<SyncedBlockErrorStateCard description={formatMessage(messages.generalErrorDescription)}>
			{onRetry && <Box xcss={styles.buttonContainer}>{button}</Box>}
		</SyncedBlockErrorStateCard>
	);
};
